import PersonAddIcon from "@mui/icons-material/PersonAdd";
import Button from "@mui/material/Button";
import {useContext, useEffect, useState} from "react";
import AppContext from "@/context/AppContext";
import {createBandFriendship, useCreatedBandFriendships} from "@/lib/api";
import {Box} from "@mui/system";

export const BandFollowButton = ({label, labelsm, band}) => {
    const {band: authenticatedBand, isAuthenticated, setSnackbar} = useContext(AppContext);
    const {bandFriendships, isLoading, isError, mutate} = useCreatedBandFriendships(authenticatedBand);
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        if (disabled === true) { // Skip when already disabled
            return;
        }
        if (!band || !authenticatedBand) {
            setDisabled(false);
            return;
        }
        if (band.id === authenticatedBand?.id) {
            setDisabled(true);
        } else {
            setDisabled(false)
        }


        if (!isLoading && !isError) {
            if (bandFriendships?.length > 0) {
                for (const bf of bandFriendships) {
                    if (bf.followed_band.id === band.id) {
                        setDisabled(true);
                        return;
                    }
                }
            }
        }

    }, [band, authenticatedBand, bandFriendships, disabled]);

    const sendRequest = async () => {
        if (!isAuthenticated) {
            setSnackbar({type: 'error', content: "Du musst Dich anmelden und zu einem Bandprofil wechseln"});
            return;
        }
        if (!authenticatedBand) {
            setSnackbar({type: 'error', content: "Du musst erst zu einem Bandprofil wechseln"});
            return;
        }

        setDisabled(true);

        const newValues = {};
        newValues["band"] = authenticatedBand.id;
        newValues["followed_band"] = band.id;
        newValues["confirmed"] = null;

        await createBandFriendship(newValues);
        mutate();
        setSnackbar("Ihr folgt jetzt dieser Band");
    }

    return (
        <>
            <Button
                color="secondary"
                variant="contained"
                fullWidth
                startIcon={<PersonAddIcon/>}
                onClick={sendRequest}
                disabled={disabled}
            >
                <Box sx={{
                    display: {xs: "inline-flex", sm: "none"},
                }}>
                    {label}
                </Box>
                <Box sx={{
                    display: {xs: "none", sm: "inline-flex"},
                }}>
                    {labelsm}
                </Box>
            </Button>
        </>
    )

}
